import { createStore } from 'vuex'
import createVuexAlong from "vuex-along";
export default createStore({
  state: {
    storeId: null,
    homebgc: null,
    installbgc: null,
    jfstore:null
  },
  getters: {
  },
  mutations: {
    setStoreId(state, storeId) {
      state.storeId = storeId
    },
    sethomebgc(state, bgc) {
      state.homebgc = bgc
    },
    setinstallbgc(state, bgc) {
      state.installbgc = bgc
    },
    setjfstore(state, jifen){
      state.jfstore = jifen
    }
  },
  actions: {
  },
  modules: {
  },
  plugins: [
    createVuexAlong({})
  ]
})
